import { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { FaPlay, FaPause } from "react-icons/fa";
import { Button } from 'primereact/button';

const HlsPlayerCustomBar = ({ src, token, totalDuration, videoStatus, onRefresh }) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const [videoError, setVideoError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const progressRef = useRef(null);
  const bufferedRef = useRef(null);
  const timeDisplayRef = useRef(null);
  const progressContainerRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current) return;

    setVideoError(false);

    const video = videoRef.current;

    const attachHls = () => {
      if (Hls.isSupported()) {
        const hls = new Hls({
          enableWorker: true,
          maxBufferLength: 30,
          fragLoadingMaxRetry: 3,
          startPosition: 0, //zaczyna od poczatku zawsze
        });

        if (token) {
          hls.config.xhrSetup = (xhr) => {
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);
          };
        }

        hls.attachMedia(video);
        hls.loadSource(src);
        hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
  console.log("Total duration (s):", data.totalduration);
});

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch(() => {}); // automatycznie start
          setIsPlaying(true);
        });

        hls.on(Hls.Events.ERROR, (_event, data) => {
          if (data.fatal) setVideoError(true);
        });

        hlsRef.current = hls;
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = src;
        video.addEventListener("loadedmetadata", () => {
          video.play().catch(() => {});
          setIsPlaying(true);
        });
        video.onerror = () => setVideoError(true);
      }
    };

    attachHls();

    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
    };
  }, [src, token]);

  // Pasek postępu
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateProgress = () => {
      const currentTime = video.currentTime;
      if (progressRef.current) progressRef.current.style.width = `${(currentTime / totalDuration) * 100}%`;
      if (bufferedRef.current && video.buffered.length > 0) {
        const bufferedEnd = video.buffered.end(video.buffered.length - 1);
        bufferedRef.current.style.width = `${(bufferedEnd / totalDuration) * 100}%`;
      }
      if (timeDisplayRef.current)
        timeDisplayRef.current.textContent = `${formatTime(currentTime)} / ${formatTime(totalDuration)}`;
    };

    video.addEventListener("timeupdate", updateProgress);
    return () => video.removeEventListener("timeupdate", updateProgress);
  }, [totalDuration]);

  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const seekVideo = (event) => {
    const video = videoRef.current;
    const container = progressContainerRef.current;
    if (!video || !container) return;

    const rect = container.getBoundingClientRect();
    const ratio = (event.clientX - rect.left) / rect.width;
    video.currentTime = ratio * totalDuration;
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`;
  };

  // if (videoError || videoStatus === "error") {
  //   return <div className="video-error">Nie można odtworzyć nagrania - playlista nie została pobrana</div>;

  // }

  if (videoError || videoStatus === "error") {
  return (
    <div className="video-error text-center p-4">
      <p className="error-text">Nie można odtworzyć nagrania – playlista nie została pobrana</p>
      <Button
        icon="pi pi-refresh"
        label="Odśwież"
        className="hls-refresh-btn"
        onClick={onRefresh}
      />
    </div>
  );
}

  return (
    <div className="hls-player-wrapper">
      <video
        ref={videoRef}
        className="transaction-video"
        controls={false}
        disablePictureInPicture
        disableRemotePlayback
      />
      {/* <div className="hls-controls">
        <button className="play-btn" onClick={togglePlay}>
  {isPlaying ? <FaPause /> : <FaPlay />}
</button>
        <div className="progress-container" ref={progressContainerRef} onClick={seekVideo}>
          <div className="buffered-bar" ref={bufferedRef}></div>
          <div className="progress-bar" ref={progressRef}></div>
          <div className="time-display" ref={timeDisplayRef}>
            00:00 / {formatTime(totalDuration)}
          </div>
        </div>
      </div> */}
      <div className="hls-controls">
  <button onClick={togglePlay}>
    {isPlaying ? <FaPause /> : <FaPlay />}
  </button>

  <div className="progress-wrapper">
    <div className="progress-container" ref={progressContainerRef} onClick={seekVideo}>
      <div className="buffered-bar" ref={bufferedRef}></div>
      <div className="progress-bar" ref={progressRef}></div>
    </div>
    <div className="time-display" ref={timeDisplayRef}>
      00:00 / {totalDuration ? formatTime(totalDuration) : "00:00"}
    </div>
  </div>
</div>
    </div>
  );
};

export default HlsPlayerCustomBar;
